import { initSection } from '../../core/shopify/init-section/index.js';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { isMobile } from '../../theme/responsive-utils';
gsap.registerPlugin(ScrollTrigger);
const NAMESPACE = '.js-balance-quadrants';
const LEAD_DOT_START_ANGLE = 225;
const ACTIVE_TILE_SCALE = 1;
const INACTIVE_TILE_SCALE = 1.06;
const ACTIVE_LABEL_OPACITY = 1;
const INACTIVE_LABEL_OPACITY = 0.45;
const ACTIVE_OVERLAY_OPACITY = 0;
const INACTIVE_OVERLAY_OPACITY = 0.4;
const ACTIVE_TILE_SCALE_TRANSITION_DURATION = '2s';
const INACTIVE_TILE_SCALE_TRANSITION_DURATION = '2s';
const SECTION_SCROLL_DISTANCE = '+=160%';
const SECTION_SCROLL_SCRUB = 4;
const LAST_SECTOR = 1;
// Progress at which to unlock scroll (45 degrees before re-entering first sector).
// = (135 - LEAD_DOT_START_ANGLE + 360) / 360 = 270 / 360 = 0.75
const LAST_SECTOR_PROGRESS = (135 - LEAD_DOT_START_ANGLE + 360) / 360;
const clamp = (value, min, max)=>{
    return Math.min(max, Math.max(min, value));
};
initSection(NAMESPACE, (section)=>{
    const root = section.querySelector('.js-balance-quadrants-root');
    const ring = section.querySelector('.js-balance-quadrants-ring');
    const tiles = Array.from(section.querySelectorAll('.js-balance-quadrants-tile'));
    if (!root || !ring || tiles.length === 0) {
        return {
            unload: null
        };
    }
    const setState = (progress)=>{
        const normalizedProgress = clamp(progress, 0, 1);
        const leadDotAngle = (LEAD_DOT_START_ANGLE + normalizedProgress * 360) % 360;
        const sector = normalizedProgress >= LAST_SECTOR_PROGRESS ? LAST_SECTOR : Math.floor(leadDotAngle / 90);
        // Sector-to-tile mapping based on grid order:
        // 0-89 (bottom-right) => tile 4 (index 3)
        // 90-179 (bottom-left) => tile 3 (index 2)
        // 180-269 (top-left) => tile 1 (index 0)
        // 270-359 (top-right) => tile 2 (index 1)
        const sectorToTileIndex = [
            3,
            2,
            0,
            1
        ];
        var _sectorToTileIndex_sector;
        const activeIndex = (_sectorToTileIndex_sector = sectorToTileIndex[sector]) !== null && _sectorToTileIndex_sector !== void 0 ? _sectorToTileIndex_sector : 0;
        // Cap ring rotation to stop at LAST_SECTOR_PROGRESS instead of full 360
        const cappedProgress = normalizedProgress >= LAST_SECTOR_PROGRESS ? LAST_SECTOR_PROGRESS : normalizedProgress;
        ring.style.transform = `rotate(${cappedProgress * 360}deg)`;
        tiles.forEach((tile, index)=>{
            const isActive = index === activeIndex;
            const opacity = isActive ? ACTIVE_OVERLAY_OPACITY : INACTIVE_OVERLAY_OPACITY;
            tile.style.setProperty('--tile-overlay-opacity', String(opacity));
            tile.style.setProperty('--tile-scale', isActive ? String(ACTIVE_TILE_SCALE) : String(INACTIVE_TILE_SCALE));
            tile.style.setProperty('--tile-scale-transition-duration', isActive ? ACTIVE_TILE_SCALE_TRANSITION_DURATION : INACTIVE_TILE_SCALE_TRANSITION_DURATION);
            tile.style.setProperty('--tile-label-opacity', isActive ? String(ACTIVE_LABEL_OPACITY) : String(INACTIVE_LABEL_OPACITY));
        });
    };
    setState(0);
    // Get header height from CSS custom property
    const getHeaderHeight = ()=>{
        const cssVarName = isMobile() ? '--header-height-mobile' : '--header-height-desktop';
        const value = getComputedStyle(document.documentElement).getPropertyValue(cssVarName).trim();
        const pixels = parseFloat(value) * (window.innerWidth / 100);
        return isNaN(pixels) ? 0 : pixels;
    };
    const scrollTrigger = ScrollTrigger.create({
        trigger: root,
        start: ()=>{
            const headerHeight = getHeaderHeight();
            return headerHeight > 0 ? `top ${headerHeight}px` : 'top top';
        },
        end: SECTION_SCROLL_DISTANCE,
        pin: true,
        scrub: SECTION_SCROLL_SCRUB,
        invalidateOnRefresh: true,
        onUpdate: (self)=>{
            setState(self.progress);
        }
    });
    return {
        unload: ()=>{
            scrollTrigger.kill();
            ring.style.transform = '';
            tiles.forEach((tile)=>{
                tile.style.setProperty('--tile-overlay-opacity', String(INACTIVE_OVERLAY_OPACITY));
                tile.style.setProperty('--tile-scale', String(INACTIVE_TILE_SCALE));
                tile.style.setProperty('--tile-scale-transition-duration', INACTIVE_TILE_SCALE_TRANSITION_DURATION);
                tile.style.setProperty('--tile-label-opacity', String(INACTIVE_LABEL_OPACITY));
            });
        }
    };
});
